export const Marquee = ({ items = [] }) => {
    const row = [...items, ...items, ...items];
    return (
        <div
            data-testid="marquee"
            className="relative overflow-hidden border-y border-ink-border py-3 md:py-4"
        >
            <div className="mh-marquee whitespace-nowrap">
                {row.map((it, i) => (
                    <span
                        key={`mq-${i}`}
                        className="mx-4 inline-flex items-center gap-4 font-display text-sm uppercase tracking-tight text-fog-primary md:text-lg"
                    >
                        {it}
                        <span aria-hidden className="inline-block h-1 w-1 rounded-full bg-[#DB162F]" />
                    </span>
                ))}
            </div>
        </div>
    );
};

export default Marquee;
